import React from 'react';
import moment from 'moment';

import {
  Button,
  Chip,
  FormControlLabel,
  Grid,
  List,
  ListItem,
  Switch as MUISwitch,
  TextField as MUITextField,
  Checkbox as MUICheckBox,
  Paper,
  FormControl,
  RadioGroup,
  Radio
} from '@material-ui/core';

import { Autocomplete } from '@material-ui/lab';

import { Help as HelpIcon } from '@material-ui/icons';

import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { FormContext, StepContext, RepeatableContext } from './context';

import HelpTooltip from './HelpTooltip';
import ImageSelector from '../ImageSelector';

class Field extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    StepContext.Consumer._currentValue.add_field(this.getTransformedProps(props));
    this.remove_field = StepContext.Consumer._currentValue.remove_field;
  }

  componentWillUnmount() {
    this.remove_field && this.remove_field(this.getTransformedProps(this.props));
  }

  getHelpTooltip(text) {
    return (
      <HelpTooltip title={text ? text : this.props.help} enterTouchDelay={100} arrow>
        <HelpIcon className="HelpIcon" />
      </HelpTooltip>
    );
  }

  wrap(field, props) {
    if (props.help) {
      field = (
        <div id={'field-' + props.id} className="HelpWrapper">
          {field}
          {this.getHelpTooltip(props.help)}
        </div>
      );
    } else {
      field = <span id={'field-' + props.id}>{field}</span>;
    }

    return field;
  }

  getTransformedProps(props) {
    if (!props) props = this.props;
    var transformedProps = { ...props };

    // This essentially checks if theres higher order props coming from the repeatable.
    if (RepeatableContext.Consumer._currentValue) {
      transformedProps = RepeatableContext.Consumer._currentValue.getRepeatableProps(this);
    }

    // This was originally an else if that seemed to cause an issue where valid criteria's weren't being evaluated
    if (props.valid) {
      transformedProps.valid = (data) => {
        if (data && props.valid.valid) {
          if (!transformedProps.id.includes('-'))
            return props.valid.valid(data[transformedProps.id]) ? true : props.valid.message;
          else return props.valid.valid(data) ? true : props.valid.message;
        } else if (data && props.valid) {
          return props.valid(data[transformedProps.id]);
        }
        return true;
      };
    } else {
      transformedProps.valid = (data) => {
        // return true
        return !props.required || (data[props.id] && (data[props.id] + '').length > 0);
      };
    }
    return transformedProps;
  }
}

class TextField extends Field {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    var {
      id,
      help,
      required,
      value,
      defaultValue,
      onChange,
      valid,
      modify,
      error,
      suppressOptional,
      ...props
    } = this.getTransformedProps();

    return this.wrap(
      <FormContext.Consumer>
        {(context) => (
          <MUITextField
            {...props}
            value={
              !(value ? value : context.formdata[id] ? context.formdata[id] : '') && defaultValue
                ? defaultValue
                : value
                ? value
                : context.formdata[id]
                ? context.formdata[id]
                : ''
            }
            onChange={(e) => {
              if (modify) {
                e.target.value = modify(e.target.value);
              }
              this.setState({ modified: true });
              onChange ? onChange(e) : ((e) => context.changeData({ [id]: e.target.value }))(e);
            }}
            error={this.state.modified && context.validation_errors[id] ? true : false}
            helperText={
              this.state.modified && context.validation_errors[id]
                ? context.validation_errors[id]
                : required || suppressOptional
                ? ' '
                : 'Optional'
            }
            variant="outlined"
          />
        )}
      </FormContext.Consumer>,
      this.props
    );
  }
}

class CheckField extends Field {
  render() {
    const { id, label, required, help, onChange, valid, value, ...props } =
      this.getTransformedProps();

    return (
      <FormControlLabel
        control={
          <FormContext.Consumer>
            {(context) => (
              <MUICheckBox
                {...props}
                color={this.props.color ? this.props.color : 'primary'}
                checked={value === true ? true : context.formdata[id] ? true : false}
                onChange={
                  onChange ? onChange : (e) => context.changeData({ [id]: e.target.checked })
                }
                variant="outlined"
              />
            )}
          </FormContext.Consumer>
        }
        label={this.wrap(<>{label}</>, this.props)}
      />
    );
  }
}

class RadioField extends Field {
  action = (id, e, options, context) => {
    let set = options[e.target.value];
    if (set) {
      console.log(id, e.target.value, options);
      console.log(context, this.props);
    }
  };

  render() {
    const {
      id,
      label,
      required,
      defaultValue,
      options,
      filterOut,
      help,
      onChange,
      valid,
      value,
      ...props
    } = this.getTransformedProps();

    // console.log('filterOut', filterOut)
    const optionList = Object.keys(options).map((key) =>
      filterOut && filterOut(key) ? undefined : (this.wrap(
        <FormControlLabel
          value={key}
          control={<Radio />}
          className={'RadioItem'}
          label={options[key].label}
          key={key}
        />,
        this.props.options[key]
      )
      )
    );

    return (
      <FormControlLabel
        control={
          <FormContext.Consumer>
            {(context) => (
              <FormControl component="fieldset">
                <RadioGroup
                  name={id}
                  {...props}
                  color={this.props.color ? this.props.color : 'primary'}
                  value={
                    !(value ? value : context.formdata[id] ? context.formdata[id] : '') &&
                    defaultValue
                      ? defaultValue
                      : value
                      ? value
                      : context.formdata[id]
                      ? context.formdata[id]
                      : ''
                  }
                  onChange={
                    onChange ? onChange : (e) => context.changeData({ [id]: e.target.value })
                  }>
                  {optionList}
                </RadioGroup>
              </FormControl>
            )}
          </FormContext.Consumer>
        }
        label={this.wrap(<>{label}</>, this.props)}
      />
    );
  }
}

class SelectField extends Field {
  render() {
    const {
      id,
      required,
      help,
      values,
      onChange,
      value,
      valid,
      suppressOptional,
      onClose,
      ...props
    } = this.getTransformedProps();

    const getValue = (context) =>
      value ? value : context.formdata[id] ? context.formdata[id] : '';

    return this.wrap(
      <FormContext.Consumer>
        {(context) => (
          <Autocomplete
            disableClearable={required}
            options={values}
            getOptionLabel={(o) => o}
            value={values?.indexOf(getValue(context)) >= 0 ? getValue(context) : null}
            onChange={(e, value) => {
              onChange ? onChange(value) : context.changeData({ [id]: value });
            }}
            onClose={(e) => (onClose ? onClose(e) : undefined)}
            renderInput={(params) => (
              <MUITextField
                {...{ ...params, ...props }}
                error={this.state.modified && context.validation_errors[id] ? true : false}
                helperText={
                  this.state.modified && context.validation_errors[id]
                    ? context.validation_errors[id]
                    : required || suppressOptional
                    ? ' '
                    : 'Optional'
                }
                variant="outlined"
              />
            )}
          />
        )}
      </FormContext.Consumer>,
      this.props
    );
  }
}

class MultiSelectField extends Field {
  render() {
    const { id, required, help, values, onChange, value, valid, suppressOptional, ...props } =
      this.getTransformedProps();

    return (
      <FormContext.Consumer>
        {(context) => (
          <Grid container className="MultiSelectField">
            <Grid item xs={12} lg={6}>
              <Autocomplete
                disableClearable
                clearOnBlur
                clearOnEscape
                options={values.filter(
                  (k) =>
                    (value ? value : context.formdata[id] ? context.formdata[id] : []).indexOf(k) <
                    0
                )}
                getOptionLabel={(o) => o}
                onChange={(e, nv) => {
                  onChange
                    ? onChange([
                        ...(value ? value : context.formdata[id] ? context.formdata[id] : []),
                        nv
                      ])
                    : context.changeData({
                        [id]: [
                          ...(value ? value : context.formdata[id] ? context.formdata[id] : []),
                          nv
                        ]
                      });
                }}
                renderInput={(params) => {
                  params.value = '';
                  return (
                    <MUITextField
                      {...{ ...params, ...props }}
                      error={this.state.modified && context.validation_errors[id] ? true : false}
                      helperText={
                        this.state.modified && context.validation_errors[id]
                          ? context.validation_errors[id]
                          : required || suppressOptional
                          ? ' '
                          : 'Optional'
                      }
                      variant="outlined"
                    />
                  );
                }}
              />
            </Grid>
            <Grid item xs={12} lg={6}>
              {(value ? value : context.formdata[id] ? context.formdata[id] : []).map((item, i) => (
                <Chip
                  label={item}
                  key={i}
                  onDelete={(e) => {
                    const data = [
                      ...(value ? value : context.formdata[id] ? context.formdata[id] : [])
                    ];
                    data.splice(i, 1);
                    onChange
                      ? onChange([...data])
                      : context.changeData({
                          [id]: [...data]
                        });
                  }}
                />
              ))}
            </Grid>
          </Grid>
        )}
      </FormContext.Consumer>
    );
  }
}

class SwitchField extends Field {
  render() {
    const { id, required, help, values, onChange, value, label, valid, ...props } =
      this.getTransformedProps();

    return this.wrap(
      <FormContext.Consumer>
        {(context) => (
          <FormControlLabel
            label={label}
            control={
              <MUISwitch
                checked={value ? value : context.formdata[id] ? context.formdata[id] : false}
                onChange={
                  onChange ? onChange : (e) => context.changeData({ [id]: e.target.checked })
                }
                {...props}
              />
            }
          />
        )}
      </FormContext.Consumer>,
      this.props
    );
  }
}

class DateField extends Field {
  render() {
    const { id, required, help, onChange, value, format, valid, suppressOptional, ...props } =
      this.getTransformedProps();

    return this.wrap(
      <FormContext.Consumer>
        {(context) => (
          <KeyboardDatePicker
            autoOk
            {...props}
            format={format ? format : 'DD/MM/YYYY'}
            value={value ? value : context.formdata[id] ? context.formdata[id] : null}
            onChange={(e) => {
              this.setState({ modified: true });
              if (onChange) return onChange(e);
              if (e) context.changeData({ [id]: e._d });
            }}
            error={this.state.modified && context.validation_errors[id] ? true : false}
            helperText={
              this.state.modified && context.validation_errors[id]
                ? context.validation_errors[id]
                : required || suppressOptional
                ? ' '
                : 'Optional'
            }
            inputVariant="outlined"
          />
        )}
      </FormContext.Consumer>,
      this.props
    );
  }

  getTransformedProps(props) {
    props = super.getTransformedProps(props);

    return {
      ...props,
      valid: (data) => {
        if (!props.required) {
          return !data[props.id] || moment(data[props.id]).isValid() ? true : 'Date is invalid';
        } else {
          if (!data[props.id]) return 'Date is required';
        }
        if (data[props.id] && !moment(data[props.id]).isValid()) {
          return 'Date is invalid';
        }
        if (props.disableFuture && data[props.id] > moment()) {
          return 'Must not be in the future';
        }
        if (props.disablePast && data[props.id] < moment()) {
          return 'Must not be in the past';
        }
        if (props.maxDate && data[props.id] > props.maxDate) {
          return 'Must be before ' + moment(props.maxDate).format('DD/MM/YYYY');
        }
        if (props.minDate && data[props.id] < props.minDate) {
          return 'Must be after ' + moment(props.minDate).format('DD/MM/YYYY');
        }
        return props.valid(data);
      }
    };
  }
}

class ButtonField extends Field {
  render() {
    const { id, label, variant, color, value, className, onClick, valid, ...props } =
      this.getTransformedProps();

    return this.wrap(
      <FormContext.Consumer>
        {(context) => (
          <Button
            {...props}
            className={className + ' SteppedFormButton'}
            variant={variant ? variant : 'contained'}
            color={color ? color : 'primary'}
            onClick={
              onClick
                ? onClick
                : () => {
                    context.changeData({ [id]: value }, () => context.next());
                  }
            }>
            {label}
          </Button>
        )}
      </FormContext.Consumer>,
      this.props
    );
  }
}

class ImageField extends Field {
  render() {
    const { id, help, accept, value, onChange, valid, required, suppressOptional, ...props } =
      this.getTransformedProps();
    const fProps = { ...this.props };

    var labelAppend;
    if (help) labelAppend = this.getHelpTooltip();
    delete fProps.help;

    return this.wrap(
      <FormContext.Consumer>
        {(context) => (
          <ImageSelector
            accept={accept ? accept : 'image/*'}
            value={value ? value : context.formdata[id] ? context.formdata[id] : null}
            onChange={
              onChange
                ? onChange
                : (e) => {
                    context.changeData({ [id]: e ? e : null });
                  }
            }
            {...props}
            labelAppend={labelAppend}
            required={required}
            helperText={
              this.state.modified && context.validation_errors[id]
                ? context.validation_errors[id]
                : required || suppressOptional
                ? ' '
                : 'Optional'
            }
          />
        )}
      </FormContext.Consumer>,
      fProps
    );
  }
}

class AddressField extends Field {
  render() {
    const {
      id,
      value,
      onChange,
      valid,
      country,
      required,
      fetchDetails,
      suppressOptional,
      ...props
    } = this.getTransformedProps();

    var autocompletionRequest;
    if (country) autocompletionRequest = { componentRestrictions: { country: country } };

    return (
      <FormContext.Consumer>
        {(context) =>
          this.wrap(
            <GooglePlacesAutocomplete
              fetchDetails
              autocompletionRequest={autocompletionRequest}
              initialValue={
                value
                  ? value.description
                    ? value.description
                    : value
                  : context.formdata[id] && context.formdata[id].description
                  ? context.formdata[id].description
                  : context.formdata[id]
              }
              onPress={(data, details) => console.log(data, details)}
              renderInput={(inputProps) => (
                <MUITextField
                  {...inputProps}
                  id={id}
                  value={inputProps.value}
                  onChange={
                    onChange
                      ? (e) => {
                          onChange(e);
                          inputProps.onChange(e);
                        }
                      : (e) => {
                          context.changeData({ [id]: e.target.value });
                          inputProps.onChange(e);
                        }
                  }
                  error={this.state.modified && context.validation_errors[id] ? true : false}
                  helperText={
                    this.state.modified && context.validation_errors[id]
                      ? context.validation_errors[id]
                      : required || suppressOptional
                      ? ' '
                      : 'Optional'
                  }
                  {...props}
                  variant="outlined"
                />
              )}
              loader={<Paper className="address-field-suggestions">Loading...</Paper>}
              renderSuggestions={(activeSuggestion, suggestions, onSuggestionSelect) =>
                suggestions.length > 0 ? (
                  <Paper className="address-field-suggestions" elevation={12}>
                    <List>
                      {suggestions.map((suggestion, index) => (
                        <ListItem
                          key={suggestion.id || index}
                          selected={activeSuggestion === index}
                          onClick={(event) => onSuggestionSelect(suggestion)}
                          role="presentation">
                          {suggestion.description}
                        </ListItem>
                      ))}
                    </List>
                  </Paper>
                ) : null
              }
              onSelect={(e) => {
                let r = {
                  description: e.description,
                  terms: e.terms,
                  address_components: e.address_components
                };
                if (fetchDetails) {
                  const service = new window.google.maps.places.PlacesService(
                    document.createElement('div')
                  );
                  service.getDetails(
                    {
                      placeId: e.place_id,
                      fields: ['address_components']
                    },
                    (data) => {
                      r.address_components = data.address_components;
                      onChange ? onChange(r) : context.changeData({ [id]: r });
                    }
                  );
                } else {
                  onChange ? onChange(r) : context.changeData({ [id]: r });
                }
              }}
            />,
            this.props
          )
        }
      </FormContext.Consumer>
    );
  }
}

export {
  TextField,
  CheckField,
  SelectField,
  DateField,
  ButtonField,
  ImageField,
  AddressField,
  SwitchField,
  MultiSelectField,
  RadioField
};
